interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  category: 'サービス',
  title: 'Services',
  sub_title: '私たちはデジタルサービス支援の',
  sub_title2: 'プロフェッショナル集団です。',
  text: '私たちはビジネス、デザイン、テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から、DXの推進やシステムの内製化を支援するデジタルイノベーションパートナー事業を展開しています。',
}
